import type { OrderResource, OrderItemWithStock, SharedOrder } from '@storefront/resources';

export function beginCheckoutEvent(order: SharedOrder) {
  const mapped = order.items.map((item) => {
    return {
      'item_name': item.variantTitle,
      'item_id': item.productId,
      'price': Number(Number(item.priceGross).toFixed(2)),
      'quantity': 1,
      ...(item.productType !== 'FLEXIBLE' && {
        quantity: Number(item.amount),
        discount: calculateItemDiscount(item),
      }),
    };
  });

  return {
    'event': 'begin_checkout',
    'ecommerce': {
      'currency': order.currency.code,
      'value': Number(order.itemsGross),
      'items': mapped,
    },
  };
}

export function purchaseEvent(order: OrderResource) {
  const mapped = order.items.map((item) => {
    return {
      'item_name': item.variantTitle,
      'item_id': item.productId,
      'price': Number(Number(item.priceGross).toFixed(2)),
      'quantity': 1,
      ...(item.product.type !== 'FLEXIBLE' && {
        quantity: Number(item.amount),
        discount: calculateItemDiscount(item),
      }),
    };
  });

  return {
    'event': 'purchase',
    'ecommerce': {
      'transaction_id': order.id,
      'currency': order.currencyCode,
      'value': Number(order.itemsGross),
      'shipping': Number(order.shippingCost),
      'items': mapped,
    },
  };
}

export function closeConvertLeadEvent(order: OrderResource) {
  return {
    'event': 'close_convert_lead',
    'currency': order.currencyCode,
    'value': Number(order.itemsGross),
  };
}

export function addShippingInfoEvent(order: SharedOrder) {
  const mapped = order.items.map((item) => {
    return {
      item_name: item.variantTitle,
      item_id: item.productId,
      price: Number(Number(item.priceGross).toFixed(2)),
      quantity: 1,
      ...(item.productType !== 'FLEXIBLE' && {
        quantity: Number(item.amount),
        discount: calculateItemDiscount(item),
      }),
    };
  });

  return {
    'event': 'add_shipping_info',
    'ecommerce': {
      currency: order.currency.code,
      value: Number(order.itemsGross),
      items: mapped,
      shipping_tier: order.shippingOptionName,
    },
  };
}

export function addPaymentInfoEvent(order: SharedOrder) {
  const mapped = order.items.map((item) => {
    return {
      'item_name': item.variantTitle,
      'item_id': item.productId,
      'price': Number(Number(item.priceGross).toFixed(2)),
      'quantity': 1,
      ...(item.productType !== 'FLEXIBLE' && {
        quantity: Number(item.amount),
        discount: calculateItemDiscount(item),
      }),
    };
  });

  return {
    'event': 'add_payment_info',
    'ecommerce': {
      'currency': order.currency.code,
      'value': Number(order.itemsGross),
      'payment_type': order.billingMethodOptionName,
      'items': mapped,
    },
  };
}

function calculateItemDiscount(item: OrderItemWithStock): number {
  if (item.regularGross === null) {
    return 0;
  }

  const regularGross = Number(item.regularGross);
  const priceGross = Number(item.priceGross);

  return Number((regularGross - priceGross).toFixed(2));
}
